import { Type } from '@angular/core';
import { JobDashboardRange } from '@pages/dashboard/job-dashboard/job-dashboard-configuration';

export enum DashboardComponentSize {
  THIRD = 'col-lg-4',
  HALF = 'col-lg-6',
  TWO_THIRDS = 'col-lg-8',
  FULL = 'col-lg-12',
}

export interface DashboardComponentConfiguration {
  component: string;
  size: DashboardComponentSize;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  configuration: any;
}

export interface Dashboard {
  id?: string;
  configuration: { items: DashboardComponentConfiguration[] };
}

export interface DashboardComponentInterface {
  setConfiguration(configuration: unknown): void;
  loadData(): void;
}

export interface DashboardComponentPair {
  view: Type<DashboardComponentInterface>;
  form: Type<unknown>;
}

export const DEFAULT_DASHBOARD_CONFIG = {
  items: [
    {
      component: 'SmartwatchDashboardComponent',
      size: DashboardComponentSize.THIRD,
      configuration: {
        title: 'Smartwatches',
        description: 'Registrierte Smartwatches',
      },
    },
    {
      component: 'WorkerDashboardComponent',
      size: DashboardComponentSize.THIRD,
      configuration: {
        title: 'Benutzer',
        description: 'Registrierte Benutzer',
      },
    },
    {
      component: 'JobDashboardComponent',
      size: DashboardComponentSize.THIRD,
      configuration: {
        dataConnectionIds: [],
        title: 'Aufträge',
        description: 'Übersicht über alle Aufträge',
        range: JobDashboardRange.ALL_TIME,
      },
    },
    {
      component: 'WorkflowDashboardComponent',
      size: DashboardComponentSize.FULL,
      configuration: {
        title: 'Workflows',
      },
    },
  ],
};
